import i18n from "../i18n";
const t = (k: string, fb?: string) => i18n.t(k, fb || k);
import { createBrowserRouter } from "react-router-dom";
import ApprovedInformationTab from "../components/approved-information-tab/approvedInformationTab";
import { AuthGuard } from "../components/authentication/auth-guard";
import ForumBlockPageReview from "../components/blog-and-forum/design-theme-blog-content/ForumBlogPreview";
import SurveyAnswers from "../components/course-construction/survey-plan/survey-detail/plan-detail/survey-answers/survey-answers";
import CreateQuestionExam from "../components/course-library/personal-exam-repository/list-exam/create-question";
import CreateQuestion from "../components/course-library/personal-exam-repository/list-question/create-question";
import DetailExam from "../components/details-exam";
import { routesConfig } from "../config/routes";
import DashboardRootPage from "../layout/dashboard/DashboardRootPage";
import DashboardRootPageCourseManagement from "../layout/dashboard/DashboardRootPageCourseManagement";
import DashboardRootPageNoMenu from "../layout/dashboard/DashboardRootPageNoMenu";
import { Permission } from "../layout/sidebar/permission.enum";
import Page403 from "../pages/403";
import Page500 from "../pages/500";
import ListAccountConfiguration from "../pages/account-configuration/ListAccountConfiguration";
import AccountRegistrationReport from "../pages/account-registration-report";
import AdminInterFacePage from "../pages/admin-interface";
import DetailAdminInterface from "../pages/admin-interface/detail-admin-interface";
import AutoScoringManagement from "../pages/auto-scoring-management";
import ManagementExerciseList from "../pages/auto-scoring-management/exercise-list";
import AutomaticMarkDetail from "../pages/automatic-mark-detail";
import AutoMarkAction from "../pages/automatic-mark-detail/auto-mark-action";
import ListExamStudent from "../pages/automatic-mark-detail/list-exam-studen";
import ManagementListScore from "../pages/automatic-mark-detail/management-table-scores";
import DetailScore from "../pages/automatic-mark-detail/management-table-scores/detail-score";
import RateAutoScore from "../pages/automatic-mark-detail/management-table-scores/rate-auto-scores";
import BlogContentPage from "../pages/blog-and-forum/blog-content";
import DetailContentPreview from "../pages/blog-and-forum/blog-content/detail-blog-content";
import DesignThemeBlogContentPage from "../pages/blog-and-forum/design-theme-blog-content";
import DetailTopicPage from "../pages/blog-and-forum/detail-topic";
import ManageContentForum from "../pages/blog-and-forum/manage-content-forum";
import AcademicLevelManagementDetail from "../pages/category-management/academic-level-management/academic-level-management-detail/AcademicLevelManagementDetail";
import AcademicLevelManagement from "../pages/category-management/academic-level-management/AcademicLevelManagement";
import AdministrativeUnitManagementDetail from "../pages/category-management/administrative-unit-management/administrative-unit-management-detail/AdministrativeUnitManagementDetail";
import AdministrativeUnitManagement from "../pages/category-management/administrative-unit-management/AdministrativeUnitManagement";
import DepartmentMajorManagement from "../pages/category-management/department-major-management/DepartmentMajorManagement";
import LecturerManagementDetail from "../pages/category-management/lecturer-management/lecturer-management-detail/LecturerManagementDetail";
import LecturerManagement from "../pages/category-management/lecturer-management/LecturerManagement";
import MinistryUsersManagementDetail from "../pages/category-management/ministry-users-management/ministry-users-management-detail/MinistryUsersManagementDetail";
import MinistryUsersManagement from "../pages/category-management/ministry-users-management/MinistryUsersManagement";
import OrganizationManagementDetail from "../pages/category-management/organization-management/organization-management-detail/OrganizationManagementDetail";
import OrganizationManagement from "../pages/category-management/organization-management/OrganizationManagement";
import PortfolioValueManagementDetail from "../pages/category-management/portfolio-value-management/portfolio-value-management-detail/PortfolioValueManagementDetail";
import PortfolioValueManagement from "../pages/category-management/portfolio-value-management/PortfolioValueManagement";
import PositionManagementDetail from "../pages/category-management/position-management/position-management-detail/PositionManagementDetail";
import PositionManagement from "../pages/category-management/position-management/PositionManagement";
import SharedCategoriesManagementDetail from "../pages/category-management/shared-categories-management/shared-categories-management-detail/SharedCategoriesManagementDetail";
import SharedCategoriesManagement from "../pages/category-management/shared-categories-management/SharedCategoriesManagement";
import StudentManagementDetail from "../pages/category-management/student-management/student-management-detail/StudentManagementDetail";
import StudentManagement from "../pages/category-management/student-management/StudentManagement";
import UniversityInfoManagementDetail from "../pages/category-management/university-info-management/university-info-management-detail/UniversityInfoManagementDetail";
import UniversityInfoManagement from "../pages/category-management/university-info-management/UniversityInfoManagement";
import UniversityManagementDetail from "../pages/category-management/university-management/university-management-detail/UniversityManagementDetail";
import UniversityManagement from "../pages/category-management/university-management/UniversityManagement";
import CertificatePage from "../pages/certificate";
import DetailCertificate from "../pages/certificate/certificate-detail";
import CertificatePageViewer from "../pages/certificate/certificate-template/preview-grape";
import Clause from "../pages/clause/Clause";
import ClauseHistory from "../pages/clause/clause-history/ClauseHistory";
import AddSurvyPage from "../pages/content-construction/add-survy/add-survy";
import ContentConstruction from "../pages/content-construction/content-construction-list";
import ContentCourseDetail from "../pages/content-construction/content-course-detail";
import ContentListCourse from "../pages/content-construction/content-list-course";
import RegistrationClassPage from "../pages/content-construction/registration-class/registration-class";
import ControlQualityCourse from "../pages/control-quality-course";
import ControlQualityLesson from "../pages/control-quality-lesson";
import ControlQualityLessonVideo from "../pages/control-quality-lesson-video";
import AssignCourseConstruction from "../pages/course-construction/assign-course-construction";
import AssignedDetailCourseConstruction from "../pages/course-construction/assigned-course-construction";
import CourseApprovalPage from "../pages/course-construction/course-browse/course-approval";
import AppraisedHistory from "../pages/course-construction/course-browse/course-approval/appraised-history";
import DetailCourseApproval from "../pages/course-construction/course-browse/course-approval/course-approval";
import CourseBrowserIndex from "../pages/course-construction/course-browse/course-browse";
import DetailCourseBrowse from "../pages/course-construction/course-browse/course-browse/course-browse";
import CourseEvaluation from "../pages/course-construction/course-browse/course-evaluation";
import DetailCourseEvaluation from "../pages/course-construction/course-browse/course-evaluation/course-evaluation";
import PublishCoursePage from "../pages/course-construction/course-browse/publish-course";
import DetailCoursePublish from "../pages/course-construction/course-browse/publish-course/course-approval";
import DetailCourseConstruction from "../pages/course-construction/detail-course-construction";
import HistoryBuildCourseConstruction from "../pages/course-construction/history-build-course-construction";
import HistoryCourseConstruction from "../pages/course-construction/history-course-construction";
import SurveyPlan from "../pages/course-construction/survey-plan";
import SurveyReportQuiz from "../pages/course-construction/survey-plan/survey-plan-detail/statistical-report-quiz";
import SurveyPlanDetail from "../pages/course-construction/survey-plan/survey-plan-detail/SurveyPlanDetail";
import CourseList from "../pages/course-management/course-list/CourseList";
import LearningProgress from "../pages/course-management/course-student-list/components/learning-progress/LearningProgress";
import CourseStudentList from "../pages/course-management/course-student-list/CourseStudentList";
import ScoreBoard from "../pages/course-management/course-student-list/score-board";
import ReviewAndDiscussion from "../pages/course-management/review-and-discussion/ReviewAndDiscussion";
import ListApprovalConfiguration from "../pages/course-plan-managment/configuration/approval-configuration";
import DetailApprovalConfiguration from "../pages/course-plan-managment/configuration/approval-configuration/mooc-approval-configuration-detail";
import ListMoocActionHistory from "../pages/course-plan-managment/mooc-action-history/mooc-action-history-list";
import AppraisalPlanList from "../pages/course-plan-managment/mooc-appraisal-plan/mooc-appraisal-plan-list";
import ApprovalCouresPlanDetail from "../pages/course-plan-managment/mooc-approval-course-plan/mooc-approval-plan-detail";
import DetailApproval from "../pages/course-plan-managment/mooc-approval-course-registration/components/approval-course-register/DetailApproval";
import MoocCourseApprovalDetail from "../pages/course-plan-managment/mooc-approval-course-registration/mooc-approval-course-detail";
import MoocApprovalCourseHistory from "../pages/course-plan-managment/mooc-approval-course-registration/mooc-approval-course-history";
import ListMoocApprovalCourseRegister from "../pages/course-plan-managment/mooc-approval-course-registration/mooc-approval-course-list";
import ApprovalPlanDetail from "../pages/course-plan-managment/mooc-approval-plan/mooc-approval-plan-detail";
import ApprovalPlanList from "../pages/course-plan-managment/mooc-approval-plan/mooc-approval-plan-list";
import DetailCoursePlan from "../pages/course-plan-managment/mooc-course-construction-plan/detail-course-plan/DetailCoursePlan";
import HistoryCourseConstructionPlan from "../pages/course-plan-managment/mooc-course-construction-plan/history-course-plan/HistoryCourseConstructionPlan";
import ListMoocCourseConstructionPlan from "../pages/course-plan-managment/mooc-course-construction-plan/list-course-plan/MoocCourseConstructionPlanList";
import CoursePlanPlanningApproval from "../pages/course-plan-managment/mooc-course-plan-planning-approval";
import CourseConstructionPlanDetail from "../pages/course-plan-managment/mooc-course-plan-planning-approval/components/mooc-course-plan-planning-approval-details";
import CoursePlanSubmitAppraisalPlan from "../pages/course-plan-managment/mooc-course-plan-submit-appraisal-plan";
import HistorySubmitAppraisalPlan from "../pages/course-plan-managment/mooc-course-plan-submit-appraisal-plan/components/history-submit-appraisal-plan/HistorySubmitAppraisalPlan";
import CoursePlanSubmitApprovalPlan from "../pages/course-plan-managment/mooc-course-plan-submit-approval-plan";
import HistorySubmitApprovalPlan from "../pages/course-plan-managment/mooc-course-plan-submit-approval-plan/components/history-submit-approval-plan/HistorySubmitApprovalPlan";
import MoocCourseAssignmentDetail from "../pages/course-plan-managment/mooc-course-planning-assignment/components/course-assignment-detail/mooc-course-assignment-detail";
import PlanningAssignment from "../pages/course-plan-managment/mooc-course-planning-assignment/components/planning-assignment";
import AssignmentHistory from "../pages/course-plan-managment/mooc-course-planning-assignment/components/planning-assignment-history/AssginmentHistory";
import PlanningAssignmentHistory from "../pages/course-plan-managment/mooc-course-planning-assignment/components/planning-assignment-history/PlanningAssignmentHistory";
import CoursePlanningAssignment from "../pages/course-plan-managment/mooc-course-planning-assignment/CoursePlanningAssigment";
import UserDocumentOrganizeAppraisal from "../pages/course-plan-managment/organize-appraisal-board/organize-appraisal-board-detail/detail-info-tab/user-document/UserDocumentOrganizeAppraisal";
import DetailOrganizeAppraisalBoard from "../pages/course-plan-managment/organize-appraisal-board/organize-appraisal-board-detail/DetailOrganizeAppraisalBoard";
import OrganizeAppraisalBoard from "../pages/course-plan-managment/organize-appraisal-board/organize-appraisal-board-list/OrganizeAppraisalBoard";
import DetailPlanningCourseConstruction from "../pages/course-plan-managment/planning-course-construction/detail-planning-course-construction/DetailPlanningCourseConstruction";
import ApproveCouresConsrtuctionHistory from "../pages/course-plan-managment/planning-course-construction/list-planning-course-construction/components/approve-coures-history/ApproveCouresHistory";
import ListPlanningCourseConstruction from "../pages/course-plan-managment/planning-course-construction/list-planning-course-construction/PlanningCourseConstructionList";
import UserDocumentSpecializedGroup from "../pages/course-plan-managment/specialized-group/specialized-group-detail/detail-info-tab/user-document/UserDocument";
import DetailSpecializedGroup from "../pages/course-plan-managment/specialized-group/specialized-group-detail/DetailSpecializedGroup";
import SpecializedGroupList from "../pages/course-plan-managment/specialized-group/specialized-group-list/SpecializedGroupList";
import ContentPreview from "../pages/course-preview/CoursePreview";
import DetailUser from "../pages/detail/Detail";
import EnrollmentConfirmation from "../pages/enrollment-confirmation";
import LocationList from "../pages/enrollment-confirmation/locations";
import Transaction from "../pages/enrollment-confirmation/transaction";
// import LearningMaterials from "../pages/learning-materials";
import SharePermissionPage from "../components/share-permission/SharePermissionPage";
import TestScheduleList from "../pages/content-construction/test-schedule";
import TestClasses from "../pages/course-management/test-classes";
import EvaluationStudents from "../pages/course-management/test-classes/components/evaluation-students/EvaluationStudents";
import PaymentViaVnpay from "../pages/enrollment-confirmation/transaction/payment-via-vnpay/PaymentViaVnpay";
import DepartmentLevel from "../pages/learning-materials/content-moderation/department-level";
import SchoolLevel from "../pages/learning-materials/content-moderation/school-level";
import BankExam from "../pages/library/bank-exam/BankExam";
import BankExamList from "../pages/library/bank-exam/components/bank-exam-list/BankExamList";
import ListExamPersonal from "../pages/library/bank-exam/components/personal-exam-repository/list-exam";
import ListQuestionPersonal from "../pages/library/bank-exam/components/personal-exam-repository/list-question";
import BankQuestion from "../pages/library/bank-question";
import AddQuestionsIntoBank from "../pages/library/bank-question/components/add-questions";
import ListOfUses from "../pages/library/bank-question/components/list-of-uses/ListOfUses";
import ListVersionsQuiz from "../pages/library/bank-question/components/list-quiz-versions/ListVersionsQuiz";
import QuestionBankDetail from "../pages/library/bank-question/components/question-bank-detail/QuestionBankDetail";
import FeedbackSample from "../pages/library/feedback-sample";
import { default as LearningMaterials, default as LearningRepository } from "../pages/library/learning-repository";
import LearningMaterialDetail from "../pages/library/learning-repository/components/LearningMaterialDetail/LearningMaterialDetail";
import MinistryExamModeration from "../pages/library/ministry-content-moderation/list-exam/ListExam";
import MinistryQuestionModeration from "../pages/library/ministry-content-moderation/list-question/ListQuestion";
import UniversityExamModeration from "../pages/library/university-content-moderation/list-exam/ListExam";
import UniversityQuestionModeration from "../pages/library/university-content-moderation/list-question/ListQuestion";
import ListMinistries from "../pages/list-ministries/ListMinistries";
import ListStudents from "../pages/list-student/ListStudents";
import ListTeacher from "../pages/list-teachers/ListTeachers";
import ListUser from "../pages/list-user/ListUser";
import Login from "../pages/login/Login";
import LogsAudit from "../pages/logs-audit";
import MaintenancePage from "../pages/maintenance-page";
import HistoryManagementPage from "../pages/management-data/history-management-data";
import SettingManagementDataPage from "../pages/management-data/setting-management-data";
import ManagementParticipatePlatform from "../pages/management-participate-platform";
import ManagementPermissionCourse from "../pages/management-permission";
import MyNotificationPage from "../pages/my-notification-page";
import Notifications from "../pages/notifications";
import NotificationDetail from "../pages/notifications/notification-detail";
import EditNotification from "../pages/notifications/notification-detail/EditNotification";
import NotificationHistory from "../pages/notifications/notification-detail/History";
import PageBuilderView from "../pages/page-builder/PageBuilderView";
import PortalAdministrationPage from "../pages/portar-adminstration";
import UniversityPageBuilderViewCourseList from "../pages/portar-adminstration/course-list/UniversityPageViewer";
import DetailPortalAdministration from "../pages/portar-adminstration/detail-portal-administration";
import UniversityPageBuilderView from "../pages/portar-adminstration/general-introduction/UniversityPageViewer";
import PreviewIntroPageCourse from "../pages/portar-adminstration/list-program/setting-intro-page/PreviewIntroPage";
import SettingIntroPage from "../pages/portar-adminstration/list-program/setting-intro-page/SettingIntroPage";
import UniversityPageBuilderViewCourseListPage from "../pages/portar-adminstration/page-course-list/UniversityPageViewer";
import ManagementGroupContent from "../pages/prediction-model/management-group-content";
import SettingPrediction from "../pages/prediction-model/setting-prediction";
import InfoCourseList from "../pages/prediction-model/setting-prediction/list-info/info-course";
import InfoProfileStudent from "../pages/prediction-model/setting-prediction/list-info/info-profile-student";
import StudentAfterJoin from "../pages/prediction-model/setting-prediction/list-info/student-after-join";
import StudentBeforeJoin from "../pages/prediction-model/setting-prediction/list-info/student-before-join";
import StudentJoin from "../pages/prediction-model/setting-prediction/list-info/student-join";
import SettingDetailModel from "../pages/prediction-model/setting-prediction/setting-detail-model";
import PreviewQuiz from "../pages/preview-quiz";
import RoleManagement from "../pages/role-management/RoleManagement";
import CourseScoringList from "../pages/scoring/course-list";
import ExerciseList from "../pages/scoring/exercise-list";
import ManagementScoreAuto from "../pages/scoring/management-scoring-auto";
import AutoMarkPermission from "../pages/scoring/management-scoring-auto/auto-mark-permission";
import ScoringDetail from "../pages/scoring/scoring-detail";
import ScoringList from "../pages/scoring/scoring-list";
import SettingPermissionCourseDetail from "../pages/setting-permission-course";
import SettingStructureCourse from "../pages/setting-structure-course";
import SettingSupervisionDetail from "../pages/setting-supervision-detail";
import Sso from "../pages/sso";
import StatisticalReporForInstructors from "../pages/statistical-report/for-instructors/intex";
import StatisticalReportForMinistry from "../pages/statistical-report/for-ministry";
import StatisticalReportForUniversity from "../pages/statistical-report/for-university";
import MyCourseDetail from "../pages/study-management/course/my-course/my-course-detail";
import ReportCourseDocument from "../pages/study-management/course/my-course/report-course-document";
import SettingIdentify from "../pages/study-management/setting-identify";
import SettingRemindCheckIn from "../pages/study-management/setting-remind-checkin";
import RemindCheckInDetail from "../pages/study-management/setting-remind-checkin/remind-checkin-detail";
import QualityEvaluation from "../pages/study-management/setting-remind-checkin/remind-checkin-detail/report-checkin/quality-evalution";
import ReportCheckInDetail from "../pages/study-management/setting-remind-checkin/remind-checkin-detail/report-checkin/report-checkin-detail";
import SurveyPublish from "../pages/survey-managment/mooc-survey-publish";
import Survey from "../pages/survey-managment/survey";
import SurveyApproval from "../pages/survey-managment/survey-approval";
import BrowseSurvey from "../pages/survey-managment/survey-browse";
import DetailSurvey from "../pages/survey-managment/survey-construction/detail-survey/DetailSurvey";
import SurveyRespond from "../pages/survey-managment/survey-respond/SurveyRespond";
import ResultChartRender from "../pages/survey-managment/survey-synthesis/components/result-chart-render";
import ListSurveyResult from "../pages/survey-managment/survey-synthesis/index";
import SurveyDetail from "../pages/survey-managment/survey-synthesis/survey-detail/index";
import ListTrainingNeed from "../pages/survey-managment/training-need/ListTrainingNeed";
import SystemLogsPage from "../pages/system-logs";
import LearningDocumentationSystem from "../pages/system-suggest-course/learning-documentation-system";
import InfoCourseSystemDetail from "../pages/system-suggest-course/learning-documentation-system/info-course-detail";
import ListStudentSystem from "../pages/system-suggest-course/list-student-system";
import FavoriteStudent from "../pages/system-suggest-course/list-student-system/favorite-student";
import InfoSystemSuggest from "../pages/system-suggest-course/list-student-system/info-system";
import SynthesisReportSystem from "../pages/system-suggest-course/synthesis-report";
import TestMath from "../pages/test-math/TestMath";
import UserInfo from "../pages/user-info";
import Account from "../pages/user-info/account/Account";
import Profile from "../pages/user-info/profile/Profile";
import ProtectedRoute from "./protect-route/ProtectRoute";

export const router = createBrowserRouter([
  {
    path: "/error/403",
    element: <Page403 />,
  },
  {
    path: "/math",
    element: <TestMath />,
  },
  {
    path: "/sso",
    element: (
      <AuthGuard>
        <Sso />
      </AuthGuard>
    ),
  },
  {
    path: "/",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: `${routesConfig.detail}/:id`,
        errorElement: <Page500 />,
        children: [{ index: true, element: <DetailUser /> }],
      },
      {
        path: routesConfig.account,
        errorElement: <Page500 />,
        children: [{ index: true, element: <Account /> }],
      },
      {
        path: routesConfig.profile,
        errorElement: <Page500 />,
        children: [{ index: true, element: <Profile /> }],
      },
      {
        path: `${routesConfig.roleManagement}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <RoleManagement title={t("Danh sách vai trò", "Danh sách vai trò")} />,
            errorElement: <Page403 />,
          },
        ],
      },
      {
        path: `${routesConfig.systemLogs}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <SystemLogsPage title={t("Nhật ký hệ thống", "Nhật ký hệ thống")} />
            ),
            errorElement: <Page403 />,
          },
        ],
      },
      {
        path: `${routesConfig.portalAdministration}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <PortalAdministrationPage title={t("Danh sách cổng thông tin", "Danh sách cổng thông tin")} />
            ),
            errorElement: <Page403 />,
          },
          {
            path: `${routesConfig.detailPortalAdministration}/:id`,
            element: <DetailPortalAdministration />,
          },
        ],
      },
      {
        path: `${routesConfig.adminInterface}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <AdminInterFacePage title={t("Thiết lập giao diện quản trị", "Thiết lập giao diện quản trị")} />
            ),
            errorElement: <Page403 />,
          },
          {
            path: `${routesConfig.detailAdminInterface}`,
            element: <DetailAdminInterface />,
          },
        ],
      },
      {
        path: `${routesConfig.certificate}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <CertificatePage title={t("Thiết lập chứng chỉ / chứng nhận", "Thiết lập chứng chỉ / chứng nhận")} />
            ),
            errorElement: <Page403 />,
          },
          {
            path: `${routesConfig.certificate}/:id`,
            element: <DetailCertificate />, //change later
          },
        ],
      },
      {
        path: `${routesConfig.managementData}`,
        errorElement: <Page500 />,
        children: [
          {
            path: routesConfig.settingManagementData,
            element: (
              <SettingManagementDataPage title={t("Thiết lập kết nối, chia sẻ dữ liệu", "Thiết lập kết nối, chia sẻ dữ liệu")} />
            ),
          },
          {
            path: `${routesConfig.historyManagementData}`,
            element: (
              <HistoryManagementPage title={t("Lịch sử kết nối, chia sẻ dữ liệu", "Lịch sử kết nối, chia sẻ dữ liệu")} />
            ),
          },
        ],
      },
      {
        path: `${routesConfig.settingIntroCourse}/:id`,
        element: <SettingIntroPage />,
      },
    ],
  },
  {
    path: routesConfig.accountSystem,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.schoolManagementParticipates,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ManagementParticipatePlatform title={t("Quản lý trường đại học đăng ký tham gia nền tảng", "Quản lý trường đại học đăng ký tham gia nền tảng")} />
            ),
          },
        ],
      },
      {
        path: routesConfig.listUsers,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ListUser title={t("Quản lý tài khoản Quản trị cơ sở", "Quản lý tài khoản Quản trị cơ sở")} />,
          },
        ],
      },
      {
        path: routesConfig.listTeachers,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ListTeacher title={t("Quản lý tài khoản giảng viên", "Quản lý tài khoản giảng viên")} />,
          },
        ],
      },
      {
        path: routesConfig.listMinistryLevels,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ListMinistries title={t("Quản lý tài khoản người dùng cấp Bộ", "Quản lý tài khoản người dùng cấp Bộ")} />
            ),
          },
        ],
      },
      {
        path: routesConfig.listStudents,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ListStudents title={t("Quản lý tài khoản sinh viên", "Quản lý tài khoản sinh viên")} />,
          },
        ],
      },
      {
        path: routesConfig.accountRegistrationReport,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <AccountRegistrationReport title={t("Báo cáo đăng ký tài khoản sinh viên", "Báo cáo đăng ký tài khoản sinh viên")} />
            ),
          },
        ],
      },
      {
        path: routesConfig.accountConfiguration,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ListAccountConfiguration title={t("Cấu hình tài khoản", "Cấu hình tài khoản")} />,
          },
        ],
      },
    ],
  },
  {
    path: `${routesConfig.certificate}${routesConfig.certificatePageViewer}/:id`,
    element: <CertificatePageViewer />,
  },

  {
    path: routesConfig.courseConstruction,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      // Xây dụng khoá học - phân công xây dựng khoá học
      {
        errorElement: <Page500 />,
        children: [
          {
            path: routesConfig.courseConstructionManagement,
            element: <ApprovedInformationTab />,
          },
        ],
      },

      {
        errorElement: <Page500 />,
        children: [
          {
            path: routesConfig.assignCourseConstruction,
            element: <AssignCourseConstruction title={t("Danh sách kế hoạch", "Danh sách kế hoạch")} />,
          },
          {
            path: `${routesConfig.assignCourseConstruction}/${routesConfig.detailAssignCourseConstruction}/:id`,
            element: <DetailCourseConstruction />,
          },
          {
            path: `${routesConfig.assignCourseConstruction}/${routesConfig.detailAssignedCourseConstruction}/:id`,
            element: <AssignedDetailCourseConstruction />,
          },
          {
            path: `${routesConfig.assignCourseConstruction}/${routesConfig.historyCourseConstruction}`,
            element: <HistoryCourseConstruction />,
          },
        ],
      },

      // Xây dụng khoá học - xây dựng nội dung
      {
        errorElement: <Page500 />,
        children: [
          {
            path: routesConfig.contentConstruction,
            element: <ContentConstruction title={t("Danh sách khóa học", "Danh sách khóa học")} />,
          },
          {
            path: `${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/:id`,
            element: <ContentCourseDetail />,
          },
          {
            path: `${routesConfig.contentConstruction}/${routesConfig.contentListCourse}/:id`,
            element: <ContentListCourse />,
          },
          {
            path: `${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/:id/${routesConfig.addLesson}`,
            element: <AddSurvyPage />,
          },
          {
            path: `${routesConfig.contentConstruction}/${routesConfig.historyCourseConstruction}`,
            element: <HistoryBuildCourseConstruction />,
          },
          {
            path: `${routesConfig.contentConstruction}/${routesConfig.historyCourseConstruction}`,
            element: <HistoryBuildCourseConstruction />,
          },
          {
            path: `${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/:id/${routesConfig.registrationClass}/:classId`,
            element: <RegistrationClassPage />,
          },
        ],
      },

      // Xây dụng khoá học - duyệt khoá học
      {
        errorElement: <Page500 />,
        children: [
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.contentBrowse}`,
            element: <CourseBrowserIndex title={t("Danh sách duyệt khoá học", "Danh sách duyệt khoá học")} />,
          },
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.courseEvaluation}`,
            element: <CourseEvaluation title={t("Danh sách thẩm định khoá học", "Danh sách thẩm định khoá học")} />,
          },
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.courseApproval}`,
            element: (
              <CourseApprovalPage title={t("Danh sách phê duyệt khoá học", "Danh sách phê duyệt khoá học")} />
            ),
          },
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.publishCourse}`,
            element: <PublishCoursePage title={t("Danh sách xuất bản khoá học", "Danh sách xuất bản khoá học")} />,
          },
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.contentBrowse}/${routesConfig.detailCourseBrowse}/:id`,
            element: <DetailCourseBrowse />,
          },
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.courseEvaluation}/${routesConfig.detailCourseEvaluation}/:id`,
            element: <DetailCourseEvaluation />,
          },
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.courseApproval}/${routesConfig.detailCourseApproval}/:id`,
            element: <DetailCourseApproval />,
          },
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.publishCourse}/${routesConfig.detailPublishCourse}/:id`,
            element: <DetailCoursePublish />,
          },
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.courseEvaluation}/${routesConfig.appraisedHistory}/:id`,
            element: <AppraisedHistory />,
          },
          {
            path: `${routesConfig.courseBrowse}/${routesConfig.courseApproval}/${routesConfig.appraisedHistory}/:id`,
            element: <AppraisedHistory />,
          },
        ],
      },
      {
        errorElement: <Page500 />,
        children: [
          {
            path: routesConfig.surveyPlan,
            element: <SurveyPlan title={t("Danh sách kế hoạch khảo sát", "Danh sách kế hoạch khảo sát")} />,
          },
          {
            path: `${routesConfig.surveyPlan}/${routesConfig.surveyPlanDetail}/:id`,
            element: <SurveyPlanDetail />,
          },
          {
            path: `${routesConfig.surveyPlan}/${routesConfig.surveyPlanDetail}/:id/${routesConfig.addSurvey}`,
            element: <AddSurvyPage isDisplaySetting={true} />,
          },
          {
            path: `${routesConfig.surveyPlan}/${routesConfig.surveyPlanDetail}/:id/${routesConfig.questionStatisticalReport}`,
            element: <SurveyReportQuiz />,
          },
          {
            path: `${routesConfig.surveyPlan}/${routesConfig.surveyPlanDetail}/:id/${routesConfig.surveyAnswerDetail}`,
            element: <SurveyAnswers />,
          },
        ],
      },
    ],
  },
  {
    path: routesConfig.courseLibrary,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.bankExam,
        element: <BankExam />,
      },
      {
        path: `${routesConfig.bankExam}/${routesConfig.bankExamList}`,
        element: (
          <BankExamList title={t("Quản lý ngân hàng đề", "Quản lý ngân hàng đề")} />
        ),
      },
      {
        path: routesConfig.bankQuestion,
        errorElement: <Page500 />,
        element: <BankQuestion />,
      },
      {
        path: `${routesConfig.bankQuestion}/:id`,
        errorElement: <Page500 />,
        element: <QuestionBankDetail />,
      },
      {
        path: `${routesConfig.bankQuestion}/:id/used`,
        errorElement: <Page500 />,
        element: <ListOfUses />,
      },
      {
        path: `${routesConfig.bankQuestion}/:id/versions`,
        errorElement: <Page500 />,
        element: <ListVersionsQuiz />,
      },
      {
        path: `${routesConfig.bankQuestion}/:id/add-questions`,
        errorElement: <Page500 />,
        element: <AddQuestionsIntoBank />,
      },
      {
        path: routesConfig.feedbackSample,
        errorElement: <Page500 />,
        element: <FeedbackSample />,
      },
      {
        errorElement: <Page500 />,
        children: [
          {
            path: `${routesConfig.personalExamRepository}/${routesConfig.listExamRepository}`,
            element: (
              <ListExamPersonal />
            ),
          },
          {
            path: `${routesConfig.personalExamRepository}/${routesConfig.listQuestionRepository}`,
            element: (
              <ListQuestionPersonal />
            ),
          },
          {
            path: `${routesConfig.personalExamRepository}/${routesConfig.listQuestionRepository}/${routesConfig.createQuestionRepository}`,
            element: (
              <CreateQuestion title={t("Thêm câu hỏi", "Thêm câu hỏi")} />
            ),
          },
          {
            path: `${routesConfig.personalExamRepository}/${routesConfig.listExamRepository}/${routesConfig.createQuestionExam}`,
            element: (
              <CreateQuestionExam />
            ),
          }
        ],
      },
      {
        errorElement: <Page500 />,
        children: [
          {
            path: `${routesConfig.ministryContentModeration}/${routesConfig.listExamRepository}`,
            element: (
              <MinistryExamModeration title={t("Kiểm duyệt nội dung cấp Bộ", "Kiểm duyệt nội dung cấp Bộ")} />
            ),
          },
          {
            path: `${routesConfig.ministryContentModeration}/${routesConfig.listQuestionRepository}`,
            element: (
              <MinistryQuestionModeration title={t("Kiểm duyệt câu hỏi cấp Bộ", "Kiểm duyệt câu hỏi cấp Bộ")} />
            ),
          },
        ],
      },
      {
        errorElement: <Page500 />,
        children: [
          {
            path: `${routesConfig.universityContentModeration}/${routesConfig.listExamRepository}`,
            element: (
              <UniversityExamModeration title={t("Kiểm duyệt nội dung cấp Trường", "Kiểm duyệt nội dung cấp Trường")} />
            ),
          },
          {
            path: `${routesConfig.universityContentModeration}/${routesConfig.listQuestionRepository}`,
            element: (
              <UniversityQuestionModeration title={t("Kiểm duyệt câu hỏi cấp Trường", "Kiểm duyệt câu hỏi cấp Trường")} />
            ),
          },
        ],
      },


      // kho học liệu

      {
        path: routesConfig.learningRepository,
        element: (
          <LearningRepository title={t("Kho học liệu", "Kho học liệu")} />
        ),
      },
      {
        path: `${routesConfig.learningRepository}/:folderId`,
        errorElement: <Page500 />,
        element: <LearningRepository />,
      },

      //chia sẻ quyền

      {
        path: `${routesConfig.sharePermission}/:shareId`,
        errorElement: <Page500 />,
        element: <SharePermissionPage />,
      },
    ],
  },
  // Quản lý danh mục
  {
    path: routesConfig.categoryManagement,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.sharedCategoriesManagement,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <SharedCategoriesManagement title={t("Danh sách danh mục dùng chung", "Danh sách danh mục dùng chung")} />
            ),
          },
        ],
      },
      {
        path: `${routesConfig.sharedCategoriesManagement}/${routesConfig.sharedCategoriesManagementDetail}/:id`,
        errorElement: <Page500 />,
        element: <SharedCategoriesManagementDetail />,
      },
      {
        path: routesConfig.portfolioValueManagement,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <PortfolioValueManagement title={t("Danh sách giá trị danh mục", "Danh sách giá trị danh mục")} />
            ),
          },
        ],
      },
      {
        path: `${routesConfig.portfolioValueManagement}/${routesConfig.portfolioValueManagementDetail}/:id`,
        errorElement: <Page500 />,
        element: <PortfolioValueManagementDetail />,
      },
      {
        path: routesConfig.universityManagement,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <UniversityManagement title={t("Danh sách cơ sở đào tạo", "Danh sách cơ sở đào tạo")} />,
          },
        ],
      },
      {
        path: `${routesConfig.universityManagement}/${routesConfig.universityManagementDetail}/:id`,
        errorElement: <Page500 />,
        element: <UniversityManagementDetail />,
      },
      {
        path: routesConfig.lecturerManagement,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <LecturerManagement title={t("Danh sách giảng viên", "Danh sách giảng viên")} />,
          },
        ],
      },
      {
        path: `${routesConfig.lecturerManagement}/${routesConfig.lecturerManagementDetail}/:id`,
        errorElement: <Page500 />,
        element: <LecturerManagementDetail />,
      },
      {
        path: routesConfig.studentManagement,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <StudentManagement title={t("Danh sách sinh viên", "Danh sách sinh viên")} />,
          },
        ],
      },
      {
        path: `${routesConfig.studentManagement}/${routesConfig.studentManagementDetail}/:id`,
        errorElement: <Page500 />,
        element: <StudentManagementDetail />,
      },
      {
        path: routesConfig.ministryUsersManagement,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <MinistryUsersManagement title={t("Danh sách người dùng cấp bộ", "Danh sách người dùng cấp bộ")} />
            ),
          },
        ],
      },
      {
        path: `${routesConfig.ministryUsersManagement}/${routesConfig.ministryUsersManagementDetail}/:id`,
        errorElement: <Page500 />,
        element: <MinistryUsersManagementDetail />,
      },
      {
        path: routesConfig.departmentMajorManagement,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <DepartmentMajorManagement title={t("Danh sách khoa", "Danh sách khoa")} />
            ),
          },
        ],
      },
      {
        path: `${routesConfig.departmentMajorManagement}/${routesConfig.departmentMajorManagementDetail}/:id`,
        errorElement: <Page500 />,
        element: <DepartmentMajorManagement />,
      },
      {
        // path: routesConfig.otherCategories,
        errorElement: <Page500 />,
        children: [
          {
            path: `${routesConfig.otherCategories}/${routesConfig.academicLevelManagement}`,
            element: (
              <AcademicLevelManagement title={t("Danh sách học vấn", "Danh sách học vấn")} />
            ),
          },
          {
            path: `${routesConfig.otherCategories}/${routesConfig.academicLevelManagement}/${routesConfig.academicLevelManagementDetail}/:id`,
            errorElement: <Page500 />,
            element: <AcademicLevelManagementDetail />,
          },
          {
            path: `${routesConfig.otherCategories}/${routesConfig.positionManagement}`,
            element: (
              <PositionManagement title={t("Danh sách chức vụ", "Danh sách chức vụ")} />
            ),
          },
          {
            path: `${routesConfig.otherCategories}/${routesConfig.positionManagement}/${routesConfig.positionManagementDetail}/:id`,
            errorElement: <Page500 />,
            element: <PositionManagementDetail />,
          },
          {
            path: `${routesConfig.otherCategories}/${routesConfig.organizationManagement}`,
            element: (
              <OrganizationManagement title={t("Danh sách tổ chức", "Danh sách tổ chức")} />
            ),
          },
          {
            path: `${routesConfig.otherCategories}/${routesConfig.organizationManagement}/${routesConfig.organizationManagementDetail}/:id`,
            errorElement: <Page500 />,
            element: <OrganizationManagementDetail />,
          },
          {
            path: `${routesConfig.otherCategories}/${routesConfig.administrativeUnitManagement}`,
            element: (
              <AdministrativeUnitManagement title={t("Danh sách đơn vị hành chính", "Danh sách đơn vị hành chính")} />
            ),
          },
          {
            path: `${routesConfig.otherCategories}/${routesConfig.administrativeUnitManagement}/${routesConfig.administrativeUnitManagementDetail}/:id`,
            errorElement: <Page500 />,
            element: (
              <AdministrativeUnitManagementDetail />
            ),
          },
          {
            path: `${routesConfig.otherCategories}/${routesConfig.universityInfoManagement}`,
            element: (
              <UniversityInfoManagement />
            ),
          },
          {
            path: `${routesConfig.otherCategories}/${routesConfig.universityInfoManagement}/${routesConfig.universityInfoManagementDetail}/:id`,
            errorElement: <Page500 />,
            element: (
              <UniversityInfoManagementDetail />
            ),
          },
        ]
      }
    ],
  },

  //tham gia khảo sát nhu cầu đào tạo
  {
    path: routesConfig.surveyStudent,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.trainingNeed,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessParticipateSurvey]}
              >
                <ListTrainingNeed title={t("Danh sách khảo sát nhu cầu đào tạo", "Danh sách khảo sát nhu cầu đào tạo")} />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.surveyRespond}/:id/:type/:theme`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessParticipateSurvey]}
              >
                <SurveyRespond />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },

  //khảo sát nhu cầu đào tạo
  {
    path: "/survey-training",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: "list-survey",
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute permissions={[Permission.CanAccessManageSurvey]}>
                <Survey title={t("Danh sách khảo sát nhu cầu đào tạo", "Danh sách khảo sát nhu cầu đào tạo")} />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "mooc-action-history-list/:id",
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[
                  Permission.CanAccessManageSurvey,
                  Permission.CanAccessParticipateSurvey,
                ]}
              >
                <ListMoocActionHistory title={t("Danh sách lịch sử thao tác", "Danh sách lịch sử thao tác")} />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "browse-survey",
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessApprovalSurvey]}
              >
                <BrowseSurvey title={t("Danh sách phê duyệt đợt khảo sát", "Danh sách phê duyệt đợt khảo sát")} />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "publish-survey",
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute permissions={[Permission.CanAccessManageSurvey]}>
                <div>{t("Chức năng xuất bản đợt khảo sát đang xây dựng", "Chức năng xuất bản đợt khảo sát đang xây dựng")}</div>
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: "publish-survey/:id",
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute permissions={[Permission.CanAccessManageSurvey]}>
                <SurveyPublish activeKey="3" title={t("Xuất bản đợt khảo sát", "Xuất bản đợt khảo sát")} />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: `survey-detail/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[
                  Permission.CanAccessManageSurvey,
                  Permission.CanAccessApprovalSurvey,
                ]}
              >
                <DetailSurvey />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: `survey-approval/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessApprovalSurvey]}
              >
                <SurveyApproval />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: routesConfig.surverList,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute permissions={[Permission.CanAccessResultSurvey]}>
                <ListSurveyResult title={t("Danh sách khảo sát nhu cầu đào tạo", "Danh sách khảo sát nhu cầu đào tạo")} />
              </ProtectedRoute>
            ),
          },
        ],
      },
      {
        path: `${routesConfig.surverList}/${routesConfig.detailSurvey}/:id`,
        element: (
          <ProtectedRoute permissions={[Permission.CanAccessResultSurvey]}>
            <SurveyDetail />
          </ProtectedRoute>
        ),
      },
      {
        path: `${routesConfig.surverList}/${routesConfig.detailSurvey}/:id/:type/:theme/:idPar`,
        element: (
          <ProtectedRoute permissions={[Permission.CanAccessResultSurvey]}>
            <SurveyRespond />
          </ProtectedRoute>
        ),
      },
      {
        path: `${routesConfig.surverList}/survey-detail/:id/:type/:theme`,
        element: (
          <ProtectedRoute permissions={[Permission.CanAccessResultSurvey]}>
            <SurveyRespond />
          </ProtectedRoute>
        ),
      },
      {
        path: `${routesConfig.surverList}/${routesConfig.detailSurvey}/render/:id`,
        element: (
          <ProtectedRoute permissions={[Permission.CanAccessResultSurvey]}>
            <ResultChartRender />
          </ProtectedRoute>
        ),
      },
      // {
      //   path: `${routesConfig.surverList}/${routesConfig.detailSurvey}/render/:id`,
      //   element: <ResultChartRender />,
      // },
    ],
  },

  // Kế hoạch khóa học
  {
    path: routesConfig.coursePlan,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      //Đăng ký kế hoạch khóa học
      {
        path: routesConfig.registerCoursePlan,
        errorElement: <Page500 />,

        children: [
          {
            path: `${routesConfig.moocCourseConstructionPlan}`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanning]}
              >
                <ListMoocCourseConstructionPlan title={t("Danh sách đăng ký kế hoạch", "Danh sách đăng ký kế hoạch")} />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.moocCourseConstructionPlan}/${routesConfig.moocCourseConstructionPlanDetail}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanning]}
              >
                <DetailCoursePlan />
              </ProtectedRoute>
            ),
          },
          //lịch sử thao tác:: /course-plan/register-course-plan/
          {
            path: `${routesConfig.moocCourseConstructionPlan}/${routesConfig.historyMoocCourseConstructionPlan}/:id`,
            element: (
              <ProtectedRoute
                permissions={[
                  Permission.CanAccessCoursePlanning,
                  Permission.CanAccessApprovalCoursePlan,
                  Permission.CanAccessApprovalRegisterCoursePlan,
                  Permission.CanAccessRegisterCoursePlan,
                ]}
              >
                <HistoryCourseConstructionPlan title={t("Danh sách lịch sử thao tác", "Danh sách lịch sử thao tác")} />
              </ProtectedRoute>
            ),
          },
        ],
      },
      //danh sach duyệt đăng ký khóa học
      {
        path: routesConfig.browseSubscriptionPlans,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessApprovalRegisterCoursePlan]}
              >
                <ListMoocApprovalCourseRegister
                  title={t("Danh sách Phê duyệt đăng ký kế hoạch", "Danh sách Phê duyệt đăng ký kế hoạch")}
                />
              </ProtectedRoute>
            ),
          },
        ],
      },
      //chi tiết duyệt đăng ký khóa học
      {
        path: `/${routesConfig.coursePlan}/${routesConfig.browseSubscriptionPlans}/${routesConfig.moocApprovalDetail}/:id`,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessApprovalRegisterCoursePlan]}
              >
                <MoocCourseApprovalDetail />
              </ProtectedRoute>
            ),
          },
        ],
      },
      //duyệt đăng ký khóa học
      {
        path: `/${routesConfig.coursePlan}/${routesConfig.browseSubscriptionPlans}/${routesConfig.approvalCourseRegister}/:id`,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessApprovalRegisterCoursePlan]}
              >
                <DetailApproval />
              </ProtectedRoute>
            ),
          },
        ],
      },
      //lịch sử duyệt đăng ký khóa học
      {
        path: `/${routesConfig.coursePlan}/${routesConfig.browseSubscriptionPlans}/${routesConfig.moocApprovalCourseHistory}/:id`,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessApprovalRegisterCoursePlan]}
              >
                <MoocApprovalCourseHistory />
              </ProtectedRoute>
            ),
          },
        ],
      },
      // phân công lập kế hoạch
      {
        path: routesConfig.planningAssignment,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanAssignment]}
              >
                <CoursePlanningAssignment
                  title={t("Danh sách đăng ký kế hoạch", "Danh sách đăng ký kế hoạch")}
                />
              </ProtectedRoute>
            ),
          },
          {
            path: ":id",
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanAssignment]}
              >
                <PlanningAssignment />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.detailAssignment}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanAssignment]}
              >
                <MoocCourseAssignmentDetail />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.planningAssignmentHistory}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanAssignment]}
              >
                <PlanningAssignmentHistory />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.assignmentHistory}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanAssignment]}
              >
                <AssignmentHistory />
              </ProtectedRoute>
            ),
          },
        ],
      },

      //Lập kế hoạch khóa học
      {
        path: routesConfig.organizeCoursePlan,
        errorElement: <Page500 />,

        children: [
          {
            path: `${routesConfig.planningCourseConstruction}`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanning]}
              >
                <ListPlanningCourseConstruction title={t("Danh sách kế hoạch xây dựng khoá học", "Danh sách kế hoạch xây dựng khoá học")} />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.planningAssignmentHistory}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanning]}
              >
                <PlanningAssignmentHistory />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.planningCourseConstructionDetail}/:id`,
            element: (
              <ProtectedRoute
                permissions={[
                  Permission.CanAccessPlanningApproval,
                  Permission.CanAccessCoursePlanning,
                ]}
              >
                <DetailPlanningCourseConstruction />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.planningCourseConstruction}/${routesConfig.ApproveCouresConsrtuctionHistory}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanning]}
              >
                <ApproveCouresConsrtuctionHistory />
              </ProtectedRoute>
            ),
          },
        ],
      },
      // Duyệt lập kế hoạch
      {
        path: routesConfig.planningApproval,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessPlanningApproval]}
              >
                <CoursePlanPlanningApproval />
              </ProtectedRoute>
            ),
          },
          {
            path: `detail/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessPlanningApproval]}
              >
                <CourseConstructionPlanDetail title={t("Duyệt lập kế hoạch", "Duyệt lập kế hoạch")} />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.approvalDetail}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessPlanningApproval]}
              >
                <ApprovalCouresPlanDetail />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.assignmentHistory}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessPlanningApproval]}
              >
                <AssignmentHistory />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.planningAssignmentHistory}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessCoursePlanAssignment]}
              >
                <PlanningAssignmentHistory />
              </ProtectedRoute>
            ),
          },
        ],
      },
      //   Lập tổ chuyên môn
      {
        path: routesConfig.specializedGroupList,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessSpecializedGroup]}
              >
                <SpecializedGroupList title={t("Danh sách tổ chuyên môn", "Danh sách tổ chuyên môn")} />
              </ProtectedRoute>
            ),
          },
          // {
          //   path: `${routesConfig.specializedGroupMemberList}/:id`,
          //   element: <FormSpecializedGroupMember  />,
          // },
          {
            path: `${routesConfig.detailSpecializedGroup}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessSpecializedGroup]}
              >
                <DetailSpecializedGroup />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.detailInfoMemberSpecializedGroup}/:userId`,
            errorElement: <Page500 />,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessSpecializedGroup]}
              >
                <UserDocumentSpecializedGroup />
              </ProtectedRoute>
            ),
          },
          // {
          //   path: "organization-history-list/:id",
          //   errorElement: <Page500 />,
          //   children: [
          //     {
          //       index: true,
          //       element: <OrganizationActionHistoryList title={t("Danh sách lịch sử thao tác", "Danh sách lịch sử thao tác")} />,
          //     },
          //   ],
          // },
        ],
      },
      //Lập hội đồng thẩm định
      {
        path: routesConfig.organizeAppraisalBoard,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessAppraisalBoard]}
              >
                <OrganizeAppraisalBoard
                  title={t("Danh sách hội đồng thẩm định", "Danh sách hội đồng thẩm định")}
                />
              </ProtectedRoute>
            ),
          },
          // {
          //   path: `${routesConfig.organizeAppraisalBoardMemberList}/:id`,
          //   element: <FormOrganizeAppraisalBoardMember />,
          // },
          {
            path: `${routesConfig.detailOrganizeAppraisalBoard}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessAppraisalBoard]}
              >
                <DetailOrganizeAppraisalBoard />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.detailInfoMemberAppraisalBoard}/:userId`,
            errorElement: <Page500 />,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessAppraisalBoard]}
              >
                <UserDocumentOrganizeAppraisal />
              </ProtectedRoute>
            ),
          },
        ],
      },
      // Gửi phê duyệt kế hoạch
      {
        path: routesConfig.submitApprovalPlan,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[
                  Permission.CanAccessApprovalCoursePlanningSending,
                ]}
              >
                <CoursePlanSubmitApprovalPlan />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.detailSpecializedGroup}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessSpecializedGroup]}
              >
                <DetailSpecializedGroup />
              </ProtectedRoute>
            ),
          },
          {
            path: `detail/:id`,
            element: (
              <ProtectedRoute
                permissions={[
                  Permission.CanAccessApprovalCoursePlanningSending,
                ]}
              >
                <CourseConstructionPlanDetail title={t("Gửi phê duyệt kế hoạch", "Gửi phê duyệt kế hoạch")} />
              </ProtectedRoute>
            ),
          },
          //lịch sử thao tác:
          {
            path: `${routesConfig.submitApprovalPlan}/${routesConfig.historySubmitApprovalPlan}/:id`,
            element: (
              <ProtectedRoute
                permissions={[
                  Permission.CanAccessApprovalCoursePlanningSending,
                  Permission.CanAccessCoursePlanning,
                ]}
              >
                <HistorySubmitApprovalPlan />
              </ProtectedRoute>
            ),
          },
        ],
      },
      // Gửi thẩm định kế hoạch
      {
        path: routesConfig.submitAppraisalPlan,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessSubmitPlanAppraisal]}
              >
                <CoursePlanSubmitAppraisalPlan />
              </ProtectedRoute>
            ),
          },
          {
            path: `${routesConfig.detailOrganizeAppraisalBoard}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessAppraisalBoard]}
              >
                <DetailOrganizeAppraisalBoard />
              </ProtectedRoute>
            ),
          },
          {
            path: `detail/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessSubmitPlanAppraisal]}
              >
                <CourseConstructionPlanDetail title={t("Gửi thẩm định kế hoạch", "Gửi thẩm định kế hoạch")} />
              </ProtectedRoute>
            ),
          },
          //lịch sử thao tác:
          {
            path: `${routesConfig.submitAppraisalPlan}/${routesConfig.historySubmitAppraisalPlan}/:id`,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessSubmitPlanAppraisal]}
              >
                <HistorySubmitAppraisalPlan />
              </ProtectedRoute>
            ),
          },
        ],
      },
      // Phê duyệt kế hoạch
      {
        path: routesConfig.approval,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[Permission.CanAccessApprovalCoursePlan]}
              >
                <ApprovalPlanList title={t("Danh sách Phê duyệt kế hoạch khoá học", "Danh sách Phê duyệt kế hoạch khoá học")} />
              </ProtectedRoute>
            ),
          },
          {
            path: "approval-detail/:id",
            errorElement: <Page500 />,
            children: [
              {
                index: true,
                element: (
                  <ProtectedRoute
                    permissions={[Permission.CanAccessApprovalCoursePlan]}
                  >
                    <ApprovalPlanDetail
                      title={t("Phê duyệt", "Phê duyệt")}
                      contentConfirm={t("phê duyệt", "phê duyệt")}
                      messageSuccess={t("Phê duyệt kế hoạch khóa học thành công", "Phê duyệt kế hoạch khóa học thành công")}
                      navigationUrl={`/${routesConfig.coursePlan}/${routesConfig.approval}`}
                    />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },

      // Thẩm định kế hoạch
      {
        path: routesConfig.appraisal,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute permissions={[Permission.CanAccessPlanAppraisal]}>
                <AppraisalPlanList title={t("Danh sách Thẩm định kế hoạch khoá học", "Danh sách Thẩm định kế hoạch khoá học")} />
              </ProtectedRoute>
            ),
          },
          {
            path: "appraisal-detail/:id",
            errorElement: <Page500 />,
            children: [
              {
                index: true,
                element: (
                  <ProtectedRoute
                    permissions={[Permission.CanAccessPlanAppraisal]}
                  >
                    <ApprovalPlanDetail
                      title={t("Thẩm định", "Thẩm định")}
                      contentConfirm={t("thẩm định", "thẩm định")}
                      messageSuccess={t("Thẩm định kế hoạch khóa học thành công", "Thẩm định kế hoạch khóa học thành công")}
                      navigationUrl={`/${routesConfig.coursePlan}/${routesConfig.appraisal}`}
                    />
                  </ProtectedRoute>
                ),
              },
            ],
          },
        ],
      },
    ],
  },

  //Quản lý khóa học
  {
    path: "/management-study",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.settingRemindCheckIn,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <SettingRemindCheckIn title={t("Danh sách khoá học", "Danh sách khoá học")} />,
          },
        ],
      },
      {
        path: `${routesConfig.settingRemindCheckIn}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <RemindCheckInDetail />,
          },
        ],
      },
      {
        path: `${routesConfig.settingRemindCheckInDetail}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <RemindCheckInDetail />,
          },
        ],
      },
      {
        path: `${routesConfig.course}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <MyCourseDetail />,
          },
        ],
      },
      {
        path: `${routesConfig.reportCheckIn}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ReportCheckInDetail />,
          },
        ],
      },
      {
        path: `${routesConfig.reportCheckInDetail}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ReportCheckInDetail />,
          },
        ],
      },
      {
        path: `${routesConfig.reportQualityEvaluation}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <QualityEvaluation />,
          },
        ],
      },
      {
        path: `${routesConfig.reportCourseDocument}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ReportCourseDocument />,
          },
        ],
      },
    ],
  },

  //Cài đặt giám sát thi cử
  {
    path: "/",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: `${routesConfig.settingSupervisionDetail}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <SettingSupervisionDetail />,
          },
        ],
      },
    ],
  },
  //Chấm bài thi tự động
  {
    path: "/",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: `setting-high-level/${routesConfig.settingIdentify}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <SettingIdentify />,
          },
        ],
      },
      {
        path: `setting-high-level/${routesConfig.controlQualityCourse}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ControlQualityCourse />,
          },
        ],
      },
      {
        path: `setting-high-level/${routesConfig.managementRoleCourse}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ManagementPermissionCourse />,
          },
        ],
      },
      {
        path: `setting-high-level/${routesConfig.controlQualityCourse}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ControlQualityCourse />,
          },
        ],
      },
      {
        path: `setting-high-level/${routesConfig.logsAudit}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <LogsAudit title={t("Nhật ký hoạt động của người dùng", "Nhật ký hoạt động của người dùng")} />,
          },
        ],
      },
      {
        path: `setting-high-level/${routesConfig.roleCourse}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <SettingPermissionCourseDetail />,
          },
        ],
      },
      {
        path: `${routesConfig.automaticMarkDetail}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <AutomaticMarkDetail />,
          },
        ],
      },
      {
        path: `${routesConfig.autoMarkActionDetail}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <AutoMarkAction />,
          },
        ],
      },
      {
        path: `${routesConfig.autoMarkPermissionDetail}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <AutoMarkPermission />,
          },
        ],
      },
      {
        path: `${routesConfig.managementListScore}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ManagementListScore />,
          },
        ],
      },
      {
        path: `${routesConfig.managementScoreDetail}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <DetailScore />,
          },
        ],
      },
      {
        path: `${routesConfig.rateAutoScore}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <RateAutoScore />,
          },
        ],
      },
    ],
  },
  //Kiểm soát chất lượng tiết học video
  {
    path: "/",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: `${routesConfig.controlQualityLesson}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ControlQualityLesson />,
          },
        ],
      },
      {
        path: `/setting-high-level/${routesConfig.controlQualityVideo}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ControlQualityLessonVideo title={t("Danh sách khoá học", "Danh sách khoá học")} />,
          },
        ],
      },
      //Cài đặt cấu trúc bài giảng
      {
        errorElement: <Page500 />,
        children: [
          {
            path: `${routesConfig.settingStructureCourse}/:id`,
            element: <SettingStructureCourse />,
          },
        ],
      },
    ],
  },
  //Hệ thống gợi khóa học
  {
    path: "/system-suggest-course",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.learningDocumentationSystem,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <LearningDocumentationSystem />,
          },
        ],
      },
      {
        path: `${routesConfig.infoCourseDetailSystem}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <InfoCourseSystemDetail />,
          },
        ],
      },
      {
        path: routesConfig.synthesisReportSystem,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <SynthesisReportSystem />,
          },
        ],
      },
      {
        path: routesConfig.listStudentSystem,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ListStudentSystem title={t("Danh sách sinh viên có cùng sở thích", "Danh sách sinh viên có cùng sở thích")} />
            ),
          },
        ],
      },
      {
        path: `${routesConfig.favoriteStudentSystem}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <FavoriteStudent />,
          },
        ],
      },
      {
        path: `${routesConfig.infoSuggestSystem}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <InfoSystemSuggest />,
          },
        ],
      },
    ],
  },

  // Mô hình dự đoán, phân tích xu hướng học tập
  {
    path: "/prediction-model",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.managementGroupContent,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <ManagementGroupContent />,
          },
        ],
      },
      {
        path: routesConfig.settingPrediction,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <SettingPrediction />,
          },
        ],
      },
      {
        path: `${routesConfig.settingDetailModel}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <SettingDetailModel />,
          },
        ],
      },
      {
        path: `${routesConfig.viewSettingDetailModel}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <SettingDetailModel />,
          },
        ],
      },
      {
        path: `${routesConfig.profileStudentModel}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <InfoProfileStudent />,
          },
        ],
      },
      {
        path: `${routesConfig.infoCourseListModel}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <InfoCourseList />,
          },
        ],
      },
      {
        path: `${routesConfig.studentBeforeJoin}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <StudentBeforeJoin />,
          },
        ],
      },
      {
        path: `${routesConfig.studentAfterJoin}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <StudentAfterJoin />,
          },
        ],
      },
      {
        path: routesConfig.studentJoin,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <StudentJoin />,
          },
        ],
      },
    ],
  },
  {
    path: `${routesConfig.examStudentList}/:id`,
    element: <ListExamStudent />,
  },
  {
    path: routesConfig.blogAndForum,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.blogContent,
        errorElement: <Page500 />,
        element: <BlogContentPage title={t("Danh sách nội dung blog", "Danh sách nội dung blog")} />,
      },
      // {
      //   path: `${routesConfig.blogContent}/${routesConfig.detailContentBlog}/:id`,
      //   errorElement: <Page500 />,
      //   element: <DetailContentPreview />,
      // },
      {
        path: routesConfig.designThemeBlogContent,
        errorElement: <Page500 />,
        element: (
          <DesignThemeBlogContentPage title={t("Thiết lập giao diện trang blog", "Thiết lập giao diện trang blog")} />
        ),
      },
      {
        path: routesConfig.manageContentForum,
        errorElement: <Page500 />,
        element: <ManageContentForum title={t("Danh sách chủ đề", "Danh sách chủ đề")} />,
      },
      {
        path: `${routesConfig.manageContentForum}/:id`,
        errorElement: <Page500 />,
        element: <DetailTopicPage />,
      },
    ],
  },

  //Cấu hình
  {
    path: routesConfig.configuration,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.approvalConfiguration,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ListApprovalConfiguration title={t("Danh sách các cấp phê duyệt", "Danh sách các cấp phê duyệt")} />
            ),
          },
        ],
      },
      {
        path: `${routesConfig.approvalConfiguration}/:id`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <DetailApprovalConfiguration />,
          },
        ],
      },
      {
        path: "mooc-action-history-list/:id",
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: (
              <ProtectedRoute
                permissions={[
                  Permission.CanAccessManageSurvey,
                  Permission.CanAccessParticipateSurvey,
                ]}
              >
                <ListMoocActionHistory title={t("Danh sách lịch sử thao tác", "Danh sách lịch sử thao tác")} />
              </ProtectedRoute>
            ),
          },
        ],
      },
    ],
  },

  {
    path: routesConfig.blogAndForum,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: routesConfig.blogContent,
        errorElement: <Page500 />,
        element: <BlogContentPage title={t("Danh sách nội dung blog", "Danh sách nội dung blog")} />,
      },
      // {
      //   path: `${routesConfig.blogContent}/${routesConfig.detailContentBlog}/:id`,
      //   errorElement: <Page500 />,
      //   element: <DetailContentPreview />,
      // },
      {
        path: routesConfig.designThemeBlogContent,
        errorElement: <Page500 />,
        element: (
          <DesignThemeBlogContentPage title={t("Thiết lập giao diện trang blog", "Thiết lập giao diện trang blog")} />
        ),
      },
      {
        path: routesConfig.manageContentForum,
        errorElement: <Page500 />,
        element: <ManageContentForum title={t("Danh sách chủ đề", "Danh sách chủ đề")} />,
      },
      {
        path: `${routesConfig.manageContentForum}/:id`,
        errorElement: <Page500 />,
        element: <DetailTopicPage />,
      },
    ],
  },

  {
    path: routesConfig.login,
    element: <Login />,
  },

  {
    path: `${routesConfig.pageBuilderView}/:id`,
    element: <PageBuilderView />,
  },
  {
    path: `${routesConfig.universityPageBuilderView}/:id`,
    element: <UniversityPageBuilderView />,
  },
  {
    path: `${routesConfig.universityPageBuilderViewCourseList}/:id`,
    element: <UniversityPageBuilderViewCourseList />,
  },
  {
    path: `${routesConfig.universityPageBuilderViewCourseListPage}/:id`,
    element: <UniversityPageBuilderViewCourseListPage />,
  },
  {
    path: `${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.coursePreview}/:id`,
    element: <ContentPreview />,
  },
  {
    path: `${routesConfig.blogAndForum}/${routesConfig.blogContent}/${routesConfig.detailContentBlog}/:id`,
    element: <DetailContentPreview />,
  },
  {
    path: `${routesConfig.courseConstruction}/${routesConfig.previewPlan}`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        element: <PreviewQuiz />,
      },
    ],
  },
  {
    path: `${routesConfig.blogAndForum}/${routesConfig.blogPreview}`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        element: <ForumBlockPageReview />,
      },
    ],
  },

  {
    path: `${routesConfig.courseConstruction}/${routesConfig.contentConstruction}/${routesConfig.contentCourseDetail}/:courseId/${routesConfig.addTestSchedule}`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        element: <TestScheduleList />
      },
    ],
  },


  {
    path: `${routesConfig.personalExamRepository}/${routesConfig.previewExam}`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        // element: <PreviewExam />,
        element: <DetailExam />
      },
    ],
  },

  {
    path: `${routesConfig.ministryContentModeration}/${routesConfig.previewExam}`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        // element: <PreviewExam />,
        element: <DetailExam />
      },
    ],
  },

  {
    path: `${routesConfig.universityContentModeration}/${routesConfig.previewExam}`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        // element: <PreviewExam />,
        element: <DetailExam />
      },
    ],
  },


  {
    path: `${routesConfig.settingIntroCourse}/${routesConfig.previewSettingIntroCourse}/:id`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        element: <PreviewIntroPageCourse />,
      },
    ],
  },

  {
    path: routesConfig.scoringManagement,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        errorElement: <Page500 />,
        element: <AutoScoringManagement title={t("Danh sách khoá học", "Danh sách khoá học")} />,
      },
      {
        path: `${routesConfig.exercises}/:id`,
        errorElement: <Page500 />,
        element: <ManagementExerciseList title={t("Danh sách bài tập", "Danh sách bài tập")} />,
      },
    ],
  },
  {
    path: routesConfig.scoringListCourse,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        errorElement: <Page500 />,
        element: <CourseScoringList title={t("Danh sách khoá học", "Danh sách khoá học")} />,
      },
      {
        path: `${routesConfig.scoringListCourse}/:id`,
        errorElement: <Page500 />,
        element: <ExerciseList title={t("Danh sách bài tập", "Danh sách bài tập")} />,
      },
      {
        path: `${routesConfig.scoringListCourse}/${routesConfig.managementScoreAuto}/:id`,
        errorElement: <Page500 />,
        element: <ManagementScoreAuto />,
      },
    ],
  },
  {
    path: `${routesConfig.courseManagement}/:courseId/${routesConfig.evaluationAndDiscussion}/:blockId/exercise/:id`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        element: <ScoringDetail />,
      },
    ],
  },
  {
    path: `${routesConfig.myNotification}`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        element: <MyNotificationPage />,
      },
    ],
  },
  {
    path: `${routesConfig.userInfo}`,
    element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        element: <UserInfo />,
      },
    ],
  },

  {
    path: routesConfig.notifications,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        errorElement: <Page500 />,
        element: <Notifications title={t("Danh sách thông báo", "Danh sách thông báo")} />,
      },
      {
        path: `${routesConfig.notifications}/:id`,
        errorElement: <Page500 />,
        element: <NotificationDetail />,
      },
      {
        path: `${routesConfig.notifications}/:id/history`,
        errorElement: <Page500 />,
        element: <NotificationHistory />,
      },
      {
        path: `${routesConfig.notifications}/:id/edit`,
        errorElement: <Page500 />,
        element: <EditNotification />,
      },
    ],
  },
  {
    path: routesConfig.enrollmentConfirmation,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        errorElement: <Page500 />,
        element: <EnrollmentConfirmation />,
      },
      {
        path: `${routesConfig.enrollmentConfirmation}/:id`,
        errorElement: <Page500 />,
        element: <Transaction />,
      },
      {
        path: `${routesConfig.enrollmentConfirmation}/vnPay`,
        errorElement: <Page500 />,
        element: <PaymentViaVnpay title={t("Danh sách giao dịch qua VNPay", "Danh sách giao dịch qua VNPay")} />,
      },
    ],
  },
  {
    path: `${routesConfig.trainingLocations}`,
    errorElement: <Page500 />,
    element: <DashboardRootPage />,
    children: [
      {
        index: true,
        errorElement: <Page500 />,
        element: <LocationList />,
      },
    ],
  },
  {
    path: "/",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: `${routesConfig.courseManagement}/${routesConfig.courseList}`,
        errorElement: <Page500 />,
        children: [
          {
            index: true,
            element: <CourseList title={t("Danh sách khoá học", "Danh sách khoá học")} />,
          },
        ],
      },
    ],
  },
  {
    path: "/",
    element: <DashboardRootPageCourseManagement />,
    errorElement: <Page500 />,
    children: [
      {
        path: `${routesConfig.courseManagement}`,
        errorElement: <Page500 />,
        children: [
          {
            path: `${routesConfig.courseManagement}/:courseId/${routesConfig.courseStudentList}`,
            errorElement: <Page500 />,
            element: <CourseStudentList />
          },
          {
            path: `${routesConfig.courseManagement}/:courseId/${routesConfig.courseStudentList}/${routesConfig.studentGPA}/:studentId`,
            errorElement: <Page500 />,
            element: <ScoreBoard />
          },
          {
            path: `${routesConfig.courseManagement}/:courseId/${routesConfig.courseStudentList}/${routesConfig.learningProgress}/:studentId`,
            errorElement: <Page500 />,
            element: <LearningProgress />
          },
          {
            path: `${routesConfig.courseManagement}/:courseId/${routesConfig.gradingList}`,
            errorElement: <Page500 />,
            element: <ExerciseList />
          },
          {
            path: `${routesConfig.courseManagement}/:courseId/${routesConfig.evaluationAndDiscussion}`,
            errorElement: <Page500 />,
            element: <ReviewAndDiscussion />
          },

          {
            path: `${routesConfig.courseManagement}/:courseId/${routesConfig.grading}/:blockId/exercise`,
            errorElement: <Page500 />,
            element: <ScoringList title={t("Danh sách bài chấm", "Danh sách bài chấm")} />,
          },

          {
            path: `${routesConfig.courseManagement}/:courseId/${routesConfig.grading}/:blockId/test-classes`,
            errorElement: <Page500 />,
            element: <TestClasses title={t("Danh sách lớp đánh giá", "Danh sách lớp đánh giá")} />,
          },
          {
            path: `${routesConfig.courseManagement}/:courseId/${routesConfig.grading}/:blockId/test-classes/:classId/students`,
            errorElement: <Page500 />,
            element: <EvaluationStudents />,
          },
        ],
      },
    ],
  },
  {
    path: "/",
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: `${routesConfig.statisticalReportForInstructors}`,
        errorElement: <Page500 />,
        index: true,
        element: (
          <StatisticalReporForInstructors title={t("Báo cáo thống kê cho giảng viên", "Báo cáo thống kê cho giảng viên")} />
        ),
      },
      {
        path: `${routesConfig.statisticalReportForMinistry}`,
        errorElement: <Page500 />,
        index: true,
        element: (
          <StatisticalReportForMinistry title={t("Báo cáo thống kê dành cho cấp Bộ", "Báo cáo thống kê dành cho cấp Bộ")} />
        ),
      },
      {
        path: `${routesConfig.statisticalReportForUniversity}`,
        errorElement: <Page500 />,
        index: true,
        element: (
          <StatisticalReportForUniversity title={t("Báo cáo thống kê dành cho trường", "Báo cáo thống kê dành cho trường")} />
        ),
      },
    ],
  },
  {
    path: `/course-library${routesConfig.learningMaterials}`,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        path: `/course-library${routesConfig.learningMaterials}`,
        errorElement: <Page500 />,
        index: true,
        element: (
          <LearningMaterials title={t("Danh sách học liệu", "Danh sách học liệu")} />
        ),
      },
      {
        path: `/course-library${routesConfig.learningMaterials}/detail/:id`,
        errorElement: <Page500 />,
        index: true,
        element: (
          <LearningMaterialDetail />
        ),
      },
      {
        path: `/course-library${routesConfig.learningMaterials}/${routesConfig.departmentLevelContentModeration}`,
        errorElement: <Page500 />,
        index: true,
        element: (
          <DepartmentLevel title={t("Danh sách kiểm duyệt nội dung cấp bộ", "Danh sách kiểm duyệt nội dung cấp bộ")} />
        ),
      },
      {
        path: `/course-library${routesConfig.learningMaterials}/${routesConfig.schoolLevelContentModeration}`,
        errorElement: <Page500 />,
        index: true,
        element: (
          <SchoolLevel title={t("Danh sách kiểm duyệt nội dung cấp trường", "Danh sách kiểm duyệt nội dung cấp trường")} />
        ),
      },
      {
        path: `/course-library${routesConfig.learningMaterials}/${routesConfig.schoolLevelContentModeration}`,
        errorElement: <Page500 />,
        index: true,
        element: (
          <SchoolLevel title={t("Danh sách học liệu", "Danh sách học liệu")} />
        ),
      },

    ],
  },
  {
    path: `${routesConfig.maintenance}`,
    // element: <DashboardRootPageNoMenu />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        element: <MaintenancePage />,
      },
    ],
  },
  {
    path: `${routesConfig.clause}`,
    element: <DashboardRootPage />,
    errorElement: <Page500 />,
    children: [
      {
        index: true,
        element: <Clause title={t("Điều khoản và chính sách", "Điều khoản và chính sách")} />,
      },
      {
        path: `${routesConfig.clauseHistory}`,
        errorElement: <Page500 />,
        element: <ClauseHistory />,
      },
    ]
  }
]);
